import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { KycModalComponent } from "@modules/kyc/components/kyc-modal/kyc-modal.component";
import { KycBannerComponent } from "@modules/kyc/kyc-banner/kyc-banner.component";
import { KycCustomerDataUpdateComponent } from "@modules/kyc/components/kyc-customer-data-update/kyc-customer-data-update.component";
import { KycSuccessComponent } from "@modules/kyc/components/kyc-success/kyc-success.component";
import { KycRoutingModule } from "@modules/kyc/kyc-routing.module";
import { SumsubService } from "@modules/kyc/services/sumsub.service";

const components = [KycModalComponent, KycBannerComponent, KycCustomerDataUpdateComponent, KycSuccessComponent];

@NgModule({
	imports: [CoreModule, KycRoutingModule],
	providers: [SumsubService],
	declarations: [...components],
	exports: [KycBannerComponent, KycModalComponent]
})
export class KycModule {}
